const latobold =
  'https://static-basket-02.wbbasket.ru/vol20/suppliers-portal-root-layout/0.0.2/6147c9b560ec4ea28987.woff2';
const lato =
  'https://static-basket-02.wbbasket.ru/vol20/suppliers-portal-root-layout/0.0.2/6313ff8e060883e53e80.woff2';

export const preloadFonts = () => {
  [lato, latobold].forEach((url) => {
    const element = document.createElement('link');

    element.href = url;
    element.rel = 'stylesheet preload prefetch';
    element.type = 'font/woff2';
    element.as = 'font';
    element.crossOrigin = 'anonymous';

    const deadline = 100000;
    let timerId: NodeJS.Timeout;
    const freeMemory = () => {
      element.onerror = null;
      element.onload = null;
      clearTimeout(timerId);
    };

    const onLoad = () => {
      freeMemory();
    };

    const onError = () => {
      freeMemory();
      console.error(`Failed load resource: ${element.href}`);
    };
    timerId = setTimeout(() => {
      freeMemory();
      console.error(
        `Failed load resource: ${element.href}. Exceeded time limit: ${deadline}`,
      );
    }, deadline);
    element.onload = onLoad;
    element.onerror = onError;

    if (document.head) {
      document.head.appendChild(element);
    }
  });
};
